export default {
    nav_my_cards: "My Cards",
    nav_mini_site: "Mini Site",
    nav_email_signature: "Email Signature",
}
